import { useContext, useEffect } from "react";
import { useState } from "react";
import api from "../services/api.js";
import { formatDate } from "./TableAddPayments.jsx";
import { DollarContext } from "../contexts/DollarContext/index.jsx";

function PaymentList() {
  const [payments, setPayments] = useState([]);
  const [orderLoadTaxes, setOrderLoadTaxes] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const dollarPriceToday = useContext(DollarContext);
  const dollarInFloat = parseFloat(
    dollarPriceToday?.replace("R$", "")?.replace(",", ".")
  );

  useEffect(() => {
    const fetchNextPayments = async () => {
      try {
        setIsLoading(true);
        const [paymentsResponse, orderLoadTaxesResponse] = await Promise.all([
          api.get("/next-payments"),
          api.get("/get-order-load-with-pending-taxes"),
        ]);
        setPayments(paymentsResponse.data);
        setOrderLoadTaxes(orderLoadTaxesResponse.data);
      } catch (error) {
        console.error("Erro ao obter próximos pagamentos: ", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchNextPayments();
  }, []);

  if (isLoading) return;

  const formattedOrderLoadTaxes = orderLoadTaxes.map((orderLoadTax) => ({
    id: orderLoadTax.id,
    payment_date: orderLoadTax.tax_payment_date,
    payment_amount: orderLoadTax.total_tax_value,
    description: "Imposto",
  }));

  let dataToRender = [...payments, ...formattedOrderLoadTaxes];

  dataToRender = dataToRender.sort(
    (a, b) => new Date(a.payment_date) - new Date(b.payment_date)
  );

  return (
    <div className="flex flex-col gap-2 -mt-52 pb-40 mx-20">
      {dataToRender.map((item) => {
        return (
          <div
            className="grid grid-cols-5 w-[100%] px-6 py-2 bg-gray-200 rounded-lg font-semibold items-center gap-24"
            key={item.id}
          >
            <p className="text-center">
              {`${
                item.description === "Imposto"
                  ? `C00${item.id}`
                  : `P00${item.order.id}`
              }-${formatDate(item.payment_date).split("/")[2]}`}
            </p>
            <p className="text-center">{formatDate(item.payment_date)}</p>
            <p className="text-center">{item.description}</p>
            <p className="text-center">
              $ {parseFloat(item.payment_amount).toFixed(2)}
            </p>
            <p className="text-center">
              R$ {parseFloat(item.payment_amount * dollarInFloat).toFixed(2)}
            </p>
          </div>
        );
      })}
    </div>
  );
}
export default PaymentList;
